import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=efb7d528&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/font.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/content.css?vue&type=style&index=1&lang=css&"
import style2 from "./Alert.vue?vue&type=style&index=2&id=efb7d528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb7d528",
  null
  
)

export default component.exports